import { getToken } from "./encryption";
import { globalConstants } from "../constants";

//Function for jwt token authorization header
export function authHeader() {
  //Return authorization header with jwt token
  const payload = getToken();

  const userToken = payload || globalConstants.EMPTY_STRING;
  if (userToken && userToken.length > 0) {
    return {
      Authorization: `Bearer ${userToken}`,
    };
  }
  return {};
}
